// ==================================
// Servicio de Pagos
// ==================================

import api from './api';
import type { Pago, Paginacion, ApiResponse } from '@/tipos';

interface FiltrosPagos {
  veterinariaId?: string;
  tipo?: string;
  estado?: string;
  fechaInicio?: string;
  fechaFin?: string;
  pagina?: number;
  limite?: number;
}

interface RespuestaPagos {
  data: Pago[];
  paginacion: Paginacion;
}

export const pagosServicio = {
  listar: async (filtros: FiltrosPagos = {}): Promise<RespuestaPagos> => {
    const params = new URLSearchParams();

    if (filtros.veterinariaId) params.append('veterinariaId', filtros.veterinariaId);
    if (filtros.tipo) params.append('tipo', filtros.tipo);
    if (filtros.estado) params.append('estado', filtros.estado);
    if (filtros.fechaInicio) params.append('fechaInicio', filtros.fechaInicio);
    if (filtros.fechaFin) params.append('fechaFin', filtros.fechaFin);
    if (filtros.pagina) params.append('pagina', filtros.pagina.toString());
    if (filtros.limite) params.append('limite', filtros.limite.toString());

    const response = await api.get<ApiResponse<RespuestaPagos>>(
      `/admin/pagos?${params.toString()}`
    );
    return response.data.data;
  },

  obtenerPorId: async (id: string): Promise<Pago> => {
    const response = await api.get<ApiResponse<Pago>>(`/admin/pagos/${id}`);
    return response.data.data;
  },
};

export default pagosServicio;
